<template>
  <div class="loyalty">
    <b-container>
      <b-row>
        <b-col sm="12" md="6" lg="4" offset-lg="1">
          <h5 class="mb-4">Ottieni la tua gift card del valore di 50 euro in punti e prova la nostra piattaforma personalizzabile.</h5>
          <p>Come richiedere la gift card e come usarla</p>
          <ol>
            <li>Compila il form in questa pagina</li>
            <li>Riceverai la gift card via email con le istruzioni per utilizzarla</li>
            <li>Dopo aver fatto login con la tua gift card, potrai scoprire la nostra soluzione e persino prenotare un soggiorno, sfruttando un credito del valore di <strong>50 euro</strong>.</li>
          </ol>
          <p class="mt-4">
            <strong class="d-block mb-1">Condizioni d'uso specifiche</strong>
            Se scegli un servizio dal valore inferiore o uguale all’importo accreditato, pagherai direttamente con il credito.
            Se scegli un servizio dal valore superiore, potrai integrare l’importo con la tua carta di credito.<br><br>
            Per utilizzare la gift card, prenota entro il <strong>31-03-2026</strong>.
          </p>
        </b-col>
        <b-col sm="12" md="6" lg="4" offset-lg="1">
          <h5 class="vb-heading mb-4">Richiedi la gift card</h5>
          <validation-observer v-slot="{ invalid }">
            <validation-provider rules="required|alpha_spaces|min:2" name="Nome" v-slot="{ errors }">
              <b-form-group label="Nome" label-class="vb-label">
                <vb-input v-model="name" :vb_options="{
                  autocomplete: 'chrome-off',
                }"/>
              </b-form-group>
              <span class="vee--errors">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider rules="required|alpha_spaces|min:2" name="Cognome" v-slot="{ errors }">
              <b-form-group label="Cognome" label-class="vb-label">
                <vb-input v-model="surname" :vb_options="{
                  autocomplete: 'chrome-off',
                }"/>
              </b-form-group>
              <span class="vee--errors">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider rules="required|alpha_spaces|min:2" name="Azienda" v-slot="{ errors }">
              <b-form-group label="Azienda" label-class="vb-label">
                <vb-input v-model="company" :vb_options="{
                  autocomplete: 'chrome-off',
                }"/>
              </b-form-group>
              <span class="vee--errors">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider rules="required|alpha_spaces|min:2" name="Ruolo" v-slot="{ errors }">
              <b-form-group label="Ruolo" label-class="vb-label">
                <vb-input v-model="role" :vb_options="{
                  autocomplete: 'chrome-off',
                }"/>
              </b-form-group>
              <span class="vee--errors">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider rules="required|email" name="Email" v-slot="{ errors }">
              <b-form-group label="Email" label-class="vb-label">
                <vb-input v-model="email" :vb_options="{
                  autocomplete: 'chrome-off',
                }"/>
              </b-form-group>
              <span class="vee--errors">{{ errors[0] }}</span>
            </validation-provider>
            <div class="mt-4">
              <validation-provider :rules="{ required:{ allowFalse: false } }" name="Condizioni d'uso" v-slot="{ errors }">
                <vb-checkbox
                    v-model="checkbox_terms"
                    :vb_options="{}">
                  <router-link :to="{name: 'terms'}" target="_blank" class="nounderline ml-1">
                    Accetto le condizioni d'uso
                  </router-link>
                </vb-checkbox>
                <span class="vee--errors mb-2">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider :rules="{ required:{ allowFalse: false } }" name="Privacy" v-slot="{ errors }">
                <vb-checkbox
                    v-model="checkbox_privacy"
                    :vb_options="{}">
                  <router-link :to="{name: 'privacy-policy'}" target="_blank" class="nounderline ml-1">
                    Accetto le condizioni di Privacy
                  </router-link>
                </vb-checkbox>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mt-4">
              <div class="loginButton" v-if="!loading">
                <vb-button
                  class="btn-block"
                  v-if="!sent_msg"
                  :vb_options="{
                    class: 'btn-block',
                    disabled: invalid,
                    text: 'Richiedi'
                  }"
                  @click="() => {
                    if (recaptcha_enabled) {
                      recaptcha()
                      return
                    }
                    send_request()
                  }"
                />
              </div>
              <loader v-else />
            </div>

            <b-alert v-if="sent_msg" class="mt-4 text-center" variant="success" show>Richiesta inviata con successo.</b-alert>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { service_handler } from '@/services'

export default {
  name: 'promo-loyalty',

  components:{
  },

  props: {
  },

  data () {
    return {
      name: '',
      surname: '',
      company: '',
      role: '',
      email: '',
      checkbox_terms: false,
      checkbox_privacy: false,
      loading: false,
      recaptcha_token: '',
      recaptcha_enabled: this.get_config().recaptcha.enabled,
      sent_msg: false,
      submitter_settings: {
        type: 'form-promo-loyalty',
        label: 'promo-loyalty',
        recipient: Vue.prototype.$config.site.emailSupport,
      },
    }
  },

  computed: {
  },

  mounted() {

    if (this.get_config().recaptcha.enabled) {
      Vue.use(VueReCaptcha, {
        siteKey: this.get_config().recaptcha.siteKey,
      })
    }
  },

  methods: {

    async recaptcha() {
      this.loading = true
      this.track_form({ event: 'promo-loyalty:submit', data: { type: 'info' } })
      try {
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('promo-loyalty')
        this.recaptcha_token = token
      } catch (e) {
        this.loading = false
        this.track_form({
          event: 'promo-loyalty:submit:fail',
          data: {
            type: 'error',
            reason: 'Recaptcha',
            message: e && e.message ? e.message : undefined,
          },
        })
        return
      }
      this.send_request({ skip_submit_event: true })
    },

    send_request(options = {}) {
      this.loading =  true
      if (!options.skip_submit_event) {
        this.track_form({ event: 'promo-loyalty:submit', data: { type: 'info' } })
      }

      let parameters = {
        recaptcha: this.recaptcha_token,
        fields: {
          name: this.name,
          surname: this.surname,
          company: this.company,
          role: this.role,
          email: this.email,
        },
        settings: this.submitter_settings
      }

      service_handler(
        'formsSubmitter',
        parameters,
        { track: { name: 'promo-loyalty', emit_submit: false } },
      )
      .then(
        (success) => {
          this.log(success.data.msg)
          this.loading = false
          this.sent_msg = true
        },
        (error) => {
          this.log('[promo-loyalty.vue] - error')
          this.log(error.response)
          this.loading = false
        }
      )

    }
  },
}
</script>


<style lang="scss">

  .loyalty {
    margin: 2*$grid-gutter-width 0;

    strong {
      font-weight: $vb-font-weight-semibold;
    }

    ol {
      padding: 0;
      margin-left: $grid-gutter-20;
    }

    li {
      margin-bottom: $grid-gutter-width / 5;
    }
  }

</style>